'use client'
import {cx} from '@local/utils/cx'
import {useRef} from 'react'

export interface AboutSplitWordsProps {
	children?;
}

export const AboutSplitWords = ({children}: AboutSplitWordsProps) => {
	const textArr = useRef(children.split(' ')).current

	return (
		<>
			{textArr.map((word, idx) => (
				<span
					key={idx}
					className={cx(
						'inline-flex mt-[-0.1em] pb-[0.1em] whitespace-break-spaces',
						'[&>span]:block lg:[&>span]:transition-opacity lg:[&>span]:ease-quad-inout [&>span]:will-change-[opacity] [&>span]:opacity-40',
					)}>
					{word.split('').map((char, innerIndex) => (
						<span
							key={`${idx}-${innerIndex}`}
							className='aboutChar'>
							{char}
						</span>
					))}
					{idx !== textArr.length - 1 && <span> </span>}
				</span>
			))}
		</>
	)
}
